import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import LoginIcon from '@mui/icons-material/Login';
import KeySharp from '@mui/icons-material/KeySharp';
import Swal from 'sweetalert2';
import { api } from '../../../../services/api';

export function FormPrimeiroAcesso(props) {
    const [Senha, setSenha] = useState('')
    const [ConfirmacaoSenha, setConfirmacaoSenha] = useState('')

    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 2].focus();
            event.preventDefault();
        }
    };

    async function handleRegistrarNovaSenha() {
        let cnpj_HTML = window.document.getElementById('outlined-basic cnpj').value;
        const cnpjUnFormat = cnpj_HTML.replace('.', '').replace('.', '').replace('/', '').replace('-', '');
        const senha_HTML = window.document.getElementById('outlined-password-input senhaPrimeiroAcesso').value;
        const ConfirmacaoSenha_HTML = window.document.getElementById('outlined-password-input ConfirmacaoSenhaPrimeiroAcesso').value;

        if (!senha_HTML) {
            return Swal.fire({
                icon: 'error',
                text: 'Informe a nova senha!',
                showConfirmButton: false,
                timer: 3000
            })
        }

        if (!ConfirmacaoSenha_HTML) {
            return Swal.fire({
                icon: 'error',
                text: 'Informe a Confirmação da nova senha!',
                showConfirmButton: false,
                timer: 3000
            })
        }

        if (senha_HTML !== ConfirmacaoSenha_HTML) {
            return Swal.fire({
                icon: 'error',
                text: 'Senhas não conferem!',
                showConfirmButton: false,
                timer: 3000
            })
        }

        const JSONEmpresa = {
            CPF_CNPJ: cnpjUnFormat,
            NovaSenha: senha_HTML
        }

        await api('/api/RegistrarNovaSenhaB2B/', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: JSONEmpresa
        }).then(() => {
            Swal.fire({
                icon: 'success',
                text: 'Senha registrada com sucesso!',
                showConfirmButton: false,
                timer: 3000
            })

            props.setSteps(1)
            props.setIsPrimeiroAcesso(false)
        })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    text: 'Erro ao cadastrar a nova Senha. ' + error + ' ' + error?.response?.data?.sqlMessage,
                    showConfirmButton: false,
                    timer: 5000
                })
                console.log(error)
            })
    }

    function getIs8Digitos(vSenha) {
        try {
            if (!vSenha) {
                return false;
            }

            if (vSenha.length < 8) {
                return false;
            }
            else {
                return true;
            }
        } catch (error) {
            console.log(`Erro em getIs8Digitos: ${error}`);
            return false
        }
    }

    function getTemMaiuscula(vSenha) {
        // Verifica se a vSenha contém ao menos uma letra maiúscula
        const temMaiuscula = /[A-Z]/.test(vSenha);

        return temMaiuscula;
    }
    function getTemMinuscula(vSenha) {
        // Verifica se a vSenha contém ao menos uma letra minuscula
        const temMinuscula = /[a-z]/.test(vSenha);

        return temMinuscula;
    }

    function getTemNumero(vSenha) {
        // Verifica se a vSenha contém ao menos um número
        const temNumero = /[0-9]/.test(vSenha);

        return temNumero;
    }

    function getTemSimbolo(vSenha) {
        // Verifica se a vSenha contém ao menos um símbolo
        const temSimbolo = /[!@#$%^&*(),.?":{}|<>]/.test(vSenha);

        return temSimbolo;
    }

    return (
        <div className='flex flex-col gap-[1rem]' >
            <div className='text-2xl'>Registrar nova senha</div>
            <TextField
                onKeyDown={handleEnter}
                value={Senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <KeySharp color='primary' />
                        </InputAdornment>
                    ),
                }}
                className={props.styles.Senha}
                id="outlined-password-input senhaPrimeiroAcesso"
                label="Nova Senha"
                type="password"
                focused
                variant="standard"
                inputProps={{
                    maxLength: 35,
                }}
            />

            <div className='text-sm mt-[-0.7rem]'>Sua senha deve conter:</div>
            <div className='mt-[-0.8rem] mb-[1rem] '>
                <div className='flex flex-row gap-[0.3rem] items-center text-xs'>
                    <div>{getIs8Digitos(Senha) ? '✅' : '❌'}</div>
                    <div className={`${getIs8Digitos(Senha) ? 'text-green-700' : 'text-red-500'}`}>De 8 á 35 caracteres</div>
                </div>
                <div className='flex flex-row gap-[0.3rem] items-center text-xs'>
                    <div>{getTemMaiuscula(Senha) ? '✅' : '❌'}</div>
                    <div className={`${getTemMaiuscula(Senha) ? 'text-green-700' : 'text-red-500'}`}>Letra MAIÚSCULA</div>
                </div>
                <div className='flex flex-row gap-[0.3rem] items-center text-xs'>
                    <div>{getTemMinuscula(Senha) ? '✅' : '❌'}</div>
                    <div className={`${getTemMinuscula(Senha) ? 'text-green-700' : 'text-red-500'}`}>Letra minúscula</div>
                </div>
                <div className='flex flex-row gap-[0.3rem] items-center text-xs'>
                    <div>{getTemNumero(Senha) ? '✅' : '❌'}</div>
                    <div className={`${getTemNumero(Senha) ? 'text-green-700' : 'text-red-500'}`}>Número</div>
                </div>
                <div className='flex flex-row gap-[0.3rem] items-center text-xs'>
                    <div>{getTemSimbolo(Senha) ? '✅' : '❌'}</div>
                    <div className={`${getTemSimbolo(Senha) ? 'text-green-700' : 'text-red-500'}`}>{'Símbolo (Ex: !@#$%)'}</div>
                </div>

                {/* <div></div> */}
            </div>

            <TextField
                onKeyDown={handleEnter}
                value={ConfirmacaoSenha}
                onChange={(e) => setConfirmacaoSenha(e.target.value)}
                required
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <KeySharp color='primary' />
                        </InputAdornment>
                    ),
                }}
                className={props.styles.Senha}
                id="outlined-password-input ConfirmacaoSenhaPrimeiroAcesso"
                label="Confirmação Nova Senha"
                type="password"
                focused
                variant="standard"
            />

            <div className={props.styles.divBotaoLogin}>
                <LoadingButton
                    className={props.styles.BotaoLogin}
                    onClick={() => handleRegistrarNovaSenha()}
                    color="primary"
                    loading={props.isLoading}
                    loadingPosition="start"
                    id="outlined-password-input btnLogin"
                    endIcon={<LoginIcon />}
                    variant="outlined"
                    disabled={!getIs8Digitos(Senha) || !getTemMaiuscula(Senha) || !getTemMinuscula(Senha) || !getTemNumero(Senha) || !getTemSimbolo(Senha)}
                >
                    {'REGISTRAR'}
                </LoadingButton>
            </div>
        </div>
    )
}